export default function (Vue, parent, _data) {
  var node_dynamic = {
    template: `
    <div class='__config__body'> 
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="基本属性" name="1">
           <el-form  label-width="105px">
            <el-form-item label="唯一标识：" v-show=false>
                <el-input v-model="data['id']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="节点名称：">
                <el-input v-model="data['name']" :disabled="!params.editable"></el-input>
            </el-form-item>
            <el-form-item label="节点序号：">
                <el-input v-model="data['sn']"></el-input>
            </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="流程控制" name="2">
           <el-form label-width="105px">
            <el-form-item label="节点类型：">
                <el-select @change='changeType' v-model="data['type']" :disabled="!params.editable">
                  <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
           
            <el-form-item label="办理部门：">
                <el-select v-model="data['groupType']" @change='changeGroupType'>
                  <el-option
                    v-for="item in groupTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="相对部门：" v-show="data['groupType'] === 'relative' ">
                <el-input v-model="data['relativeGroupName']" style="width:60%;" :disabled="true"></el-input>
                <el-button type="primary" @click="showDept">选择</el-button>
            </el-form-item>
             <el-form-item label="相对部门" v-show="false">
                  <el-input v-model="data['relativeGroup']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="部门字段："  v-show="data['groupType'] === 'biz' ">
                <el-input v-model="data['groupField']"></el-input>
            </el-form-item>
            <el-form-item label="部门经办节点：" v-show="data['groupType'] === 'handled-group' ">
                <el-input v-model="data['groupHandledActName']"  :disabled="true" style="width:60%;"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'groupHandled', name:'groupHandledActName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="部门经办节点" v-show="false">
                  <el-input v-model="data['groupHandled']" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="部门范围：" v-show="data['groupType']!='bind-group'">
                <el-select v-model="data['group']">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="办理用户：">
                <el-select v-model="data['userType']">
                  <el-option
                    v-for="item in userTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="用户权限：" v-show="data['userType'] === 'role' ">
              <el-input v-model="data['userRoleName']" style="width:60%" :disabled="true"></el-input>
              <el-button type="primary" @click="showRole({id:'userRole', name:'userRoleName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="用户权限" v-show="false">
              <el-input v-model="data['userRole']" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="用户字段：" v-show="data['userType']=== 'biz' ">
                <el-input v-model="data['userField']"></el-input>
            </el-form-item>
            <el-form-item label="用户经办节点：" v-show="data['userType'] === 'handled-user' ">
                <el-input v-model="data['userHandledActName']"  :disabled="true" style="width:60%"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'userHandled', name:'userHandledActName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="用户经办节点" v-show="false">
                  <el-input v-model="data['userHandled']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="排除条件："  v-show="data['groupType']!='bind-group'">
              <el-radio-group v-model="data['excludeSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排除范围：" v-show="data['excludeSwitch']== '1' && data['groupType']!='bind-group'">
                <el-select v-model="data['excludeType']">
                  <el-option
                    v-for="item in excludeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="表单控制" name="3">
           <el-form  label-width="105px">
            <el-form-item label="操作按钮：">
                <el-button type="primary" @click="showFlowButton()">选择</el-button>
            </el-form-item>
            <div style="padding:5px;border:1px #ddd solid" v-show="data.buttons.length>0">
              <el-button  :key="button.id" v-for="button in data.buttons">{{button.name}}
              </el-button>
            </div>
            <el-form-item label="操作权限：">
                <el-button type="primary" @click="showFormOperAuth()">选择</el-button>
            </el-form-item>
             <div style="padding:5px;border:1px #ddd solid" v-show="data.operAuths.length>0">
                 <el-button  :key="auth.id" v-for="auth in data.operAuths">{{auth.name}}
                 </el-button>
            </div>
            <el-form-item label="启用转办：">
              <el-radio-group v-model="data['transmitSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="转办范围：" v-show="data['transmitSwitch']==='1'">
                <el-select v-model="data['transmitScope']">
                  <el-option
                    v-for="item in transmitScopes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
               <el-form-item label="意见控制：">
              <el-radio-group v-model="data['commentSwitch']" size="mini">
                <el-radio-button label="1">展开</el-radio-button>
                <el-radio-button label="0">折叠</el-radio-button>
                </el-radio-group>
               </el-form-item>
               <el-form-item label="意见分类：" v-show="data['commentSwitch']=='1'">
                <el-input v-model="data['commentCategory']"></el-input>
            </el-form-item>
            <el-form-item label="意见序号：" v-show="data['commentSwitch']=='1'">
                <el-input v-model="data['commentSn']"></el-input>
            </el-form-item>
            <el-form-item label="默认意见：" v-show="data['commentSwitch']=='1'">
                <el-input v-model="data['defaultComment']"></el-input>
            </el-form-item>
            <el-form-item label="填写多条意见：" v-show="data['commentSwitch']=='1'">
                <el-radio-group v-model="data['moreCommentSwitch']">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="修改意见范围：" v-show="data['commentSwitch']=='1'">
                <el-select v-model="data['commentModifyScope']">
                  <el-option
                    v-for="item in commentModifyScopes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="检查方式：" v-show="data['commentSwitch']=='1'">
                <el-select v-model="data['commentCheckMode']">
                  <el-option
                    v-for="item in commentCheckModes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="完成强制填写：" v-show="data['commentSwitch']=='1'">
                <el-select v-model="data['completeComment']">
                  <el-option
                    v-for="item in mandatoryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
               </el-form-item>
               <el-form-item label="转办强制填写：" v-show="data['commentSwitch']=='1'">
                 <el-select v-model="data['transmitComment']">
                  <el-option
                    v-for="item in mandatoryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
               </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="秘书代办" name="4" v-show="false">
            <el-form  label-width="105px">
              <el-form-item label="启用秘书代办：">
              <el-radio-group v-model="data['secretarySwitch']">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
                </el-radio-group>
               </el-form-item>
               <el-form-item label="秘书代办流程：" v-show="data['secretarySwitch']==='1'">
               <el-radio-group v-model="data['secretarySubProcSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
               </el-form-item>
               <el-form-item label="代办流程名称：" v-show="data['secretarySwitch']==='1' && data['secretarySubProcSwitch'] === '1'">
                    <el-input v-model="data['secSubProcessDefName']" style="width:60%;" :disabled="true"></el-input>
                    <el-button type="primary" @click="showSubProcess">选择</el-button>
                </el-form-item>
                <el-form-item label="代办流程Key" v-show="false">
                    <el-input v-model="data['secSubProcessDefKey']" :disabled="true"></el-input>
                </el-form-item>
                 <el-form-item label="代办流程模块" v-show="false">
                <el-input v-model="data['secSubProcessModuleId']" :disabled="true"></el-input>
                <el-input v-model="data['secSubProcessApplicationId']" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="秘书代办节点：" v-show="data['secretarySwitch']==='1' && data['secretarySubProcSwitch'] === '1'">
                    <el-input v-model="data['subProcessSecActivityName']" style="width:60%;" :disabled="true"></el-input>
                    <el-button type="primary" @click="showSubProcessNode('subProcessSecActivityId', 'subProcessSecActivityName')">选择</el-button>
                </el-form-item>
                <el-form-item label="秘书代办节点ID" v-show="false">
                    <el-input v-model="data['subProcessSecActivityId']" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="领导代办节点：" v-show="data['secretarySwitch']==='1' && data['secretarySubProcSwitch'] === '1'">
                    <el-input v-model="data['subProcessLeaderActivityName']" style="width:60%;" :disabled="true"></el-input>
                    <el-button type="primary" @click="showSubProcessNode('subProcessLeaderActivityId', 'subProcessLeaderActivityName')">选择</el-button>
                </el-form-item>
                <el-form-item label="领导代办节点ID" v-show="false">
                    <el-input v-model="data['subProcessLeaderActivityId']" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="秘书节点提示" v-show="false && data['secretarySwitch']==='1' && data['secretarySubProcSwitch'] === '1'">
                    <el-input v-model="data['subProcessSecActivityTip']"></el-input>
                </el-form-item>
                <el-form-item label="领导节点提示" v-show="false && data['secretarySwitch']==='1' && data['secretarySubProcSwitch'] === '1'">
                    <el-input v-model="data['subProcessLeaderActivityTip']"></el-input>
                </el-form-item>
                <el-form-item label="秘书节点名：" v-show="data['secretarySwitch']==='1' && data['secretarySubProcSwitch'] != '1'">
                    <el-input v-model="data['secActivityName']"></el-input>
                </el-form-item>
                <el-form-item label="领导节点名：" v-show="data['secretarySwitch']==='1' && data['secretarySubProcSwitch'] != '1'">
                    <el-input v-model="data['leaderActivityName']"></el-input>
                </el-form-item>
               <el-form-item label="代录节点流向：">
                <el-input v-model="data['canAgentRecordFlowNames']"  :disabled="true" style="width:50%"></el-input>
                <el-button type="primary" @click="showCanAgentRecordFlows({id:'canAgentRecordFlowIds', name:'canAgentRecordFlowNames'})">选择</el-button>
                 <el-tooltip placement="top" style="width:10%">
                  <div slot="content">
                  配置"虚拟日志"操作按钮后生效</div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
               </el-form-item>
               <el-form-item label="代录节点ID" v-show="false">
                  <el-input v-model="data['canAgentRecordFlowIds']" :disabled="true"></el-input>
              </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="其他" name="5">
           <el-form  label-width="105px">
              <el-form-item label="时限控制：">
              <el-radio-group v-model="data['timeSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="时间类型：" v-show="data['timeSwitch']=='1'">
                <el-select v-model="data['timeType']">
                  <el-option
                    v-for="item in timeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="签收限办时间：" v-show="data['timeSwitch']=='1'">
                  <el-input v-model="data['claimLimitedTime']"></el-input>
              </el-form-item>
              <el-form-item label="办毕限办时间：" v-show="data['timeSwitch']=='1'">
                  <el-input v-model="data['finishLimitedTime']"></el-input>
              </el-form-item>
              <el-form-item label="执行脚本：">
                <el-button type="primary" @click="showFlowScriptSet('node')">设置</el-button>
            </el-form-item>
            </el-form>
        </el-collapse-item>
      </el-collapse>
      </div>
    `,
    props: {
      data: {
        type: Object
      },
      params:{
        type: Object
      }
    },
    data() {
      return {
        fields:['id','name','type','sn','groupType','group','relativeGroup', 'relativeGroupName',
          'groupField','groupHandled','groupHandledActName','userType','userRole','userRoleName','userField','userHandledActName',
          'userHandled','excludeSwitch','excludeType','buttons','operAuths','scriptActions','timeSwitch','timeType','claimLimitedTime','finishLimitedTime',
          'transmitSwitch','transmitScope',  'commentSwitch', 'commentCategory', 'commentSn',
          'defaultComment', 'moreCommentSwitch', 'commentModifyScope', 'commentCheckMode',
          'completeComment', 'transmitComment',
          'secretarySwitch','secretarySubProcSwitch','secSubProcessDefName','secSubProcessDefKey','secSubProcessModuleId','secSubProcessApplicationId',
          'subProcessSecActivityName','subProcessSecActivityId','subProcessLeaderActivityName','subProcessLeaderActivityId',
          'subProcessSecActivityTip','subProcessLeaderActivityTip','secActivityName','leaderActivityName',
         'canAgentRecordFlowNames','canAgentRecordFlowIds'],

        activeName: '1',
        types:[],

        groupTypes:[{value:'role',label:'权限'},{value:'relative',label:'相对部门'},{value:'handled-group',label:'经办'},{value:'biz',label:'业务指定'},{value:'upper-group',label:'发送部门'},{value:'draft-group',label:'发起部门'},{value:'bind-group',label:'<绑定部门>'}],

        groups:[{value:'<当前>', label:'<当前>'},{value:'<上级>', label:'<上级>'}, {value:'<下级>', label:'<下级>'}, {value:'<平级>', label:'<平级>'},
          {value:'<当前和上级>', label:'<当前和上级>'},{value:'<当前和下级>', label:'<当前和下级>'},
          {value:'<所有下级>', label:'<所有下级>'}, {value:'<上级的平级>', label:'<上级的平级>'},
          {value:'<本部门任选>', label:'<本部门任选>'},{value:'<部门上级>', label:'<部门上级>'}, {value:'<部门下级>', label:'<部门下级>'}, {value:'<部门平级>', label:'<部门平级>'},
          {value:'<本单位任选>', label:'<本单位任选>'},{value:'<本单位任选(不包含下级)>', label:'<本单位任选(不包含下级)>'},
          {value:'<本单位的一级部门>', label:'<本单位的一级部门>'},{value:'<单位上级>', label:'<单位上级>'},{value:'<单位平级>', label:'<单位平级>'},
          {value:'<上级单位部门>', label:'<上级单位部门>'},{value:'<上级单位任选>', label:'<上级单位任选>'}/*, {value:'<任选>', label:'<任选>'}*/],
        defaultUserTypes:[{value:'role',label:'权限'}, {value:'handled-user',label:'经办'},{value:'biz',label:'业务指定'},{value:'draft-user',label:'发起人'},{value:'upper-user',label:'发送人'}],
        bindUserTypes:[{value:'bind-leader',label:'<绑定领导>'},{value:'bind-secretary',label:'<绑定秘书>'}],
        circularScopes:[{value:'<当前>', label:'<当前>'},{value:'<经办人>', label:'<经办人>'},{value:'<本部门任选>', label:'<本部门任选>'}, {value:'<本单位任选>', label:'<本单位任选>'},{value:'<任选>', label:'<任选>'}],
        timeTypes:[{value:'work', label:'工作时间(单位:h)'}, {value:'reality', label:'实际时间(单位:h)'}, {value:'biz', label:'业务字段'}],
        transmitScopes:[{value:'<当前>', label:'<当前>'},{value:'<本部门任选>', label:'<本部门任选>'}, {value:'<本单位任选>', label:'<本单位任选>'},{value:'<任选>', label:'<任选>'}],
        excludeTypes:[{value:'current-user', label:'当前用户'},{value:'current-dep', label:'当前部门'}],
        commentCheckModes:[{value:'task', label:'当前环节'}, {value:'activity', label:'当前节点'}, {value:'doc', label:'当前文档'}],
        commentModifyScopes:[{value:'disabled', label:'禁止'},{value:'self', label:'本人'},{value:'all', label:'所有人'}],
        mandatoryOptions:[{value:'no', label:'否'}, {value:'remind', label:'提示'}, {value:'yes', label:'是'}]
      };
    },
    created() {
      let me=this;
      me.clearField();
      me.types=me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function (val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", {id: me.data.id, name: val})
        }
      },
      'data.id': function (val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name
          this.$set(this.data, 'name', '自由节点')
        }
        this.initData();
      }
    },
    methods: {
      initData(){
        var me = this;
        if(this.data.groupType == undefined){
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }
        if('bind-group'==me.data.groupType){
          me.userTypes = me.bindUserTypes;
        }else{
          me.userTypes = me.defaultUserTypes;
        }
       // this.$set(this.data, 'multipleUnit', '0');
        if(me.data.name == undefined) {
          this.$set(me.data, 'name', '自由节点')
        }
        if(this.data.excludeSwitch == undefined){
          this.$set(this.data, 'excludeSwitch', '0');
        }
        if(this.data.buttons == undefined){
          this.$set(this.data, 'buttons', []);
        }
        if(this.data.scriptActions == undefined){
          this.$set(this.data, 'scriptActions', {});
        }
        if(this.data.operAuths == undefined){
          this.$set(this.data, 'operAuths', []);
        }
        if(this.data.type == undefined){
          this.$set(this.data, 'type', 'dynamic');
        }

        if(this.data.group == undefined){
          this.$set(this.data, 'group', '<当前>');
        }

        if(this.data.userType == undefined){
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if(this.data.timeSwitch == undefined){
          this.$set(this.data, 'timeSwitch', '0');
        }
        if(this.data.timeType == undefined){
          this.$set(this.data, 'timeType', 'work');
        }
        if(this.data.excludeType == undefined){
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }
        if(this.data.transmitSwitch == undefined){
          this.$set(this.data, 'transmitSwitch', '0');
        }
        if(this.data.transmitScope == undefined){
          this.$set(this.data, 'transmitScope', this.transmitScopes[0].value);
        }
        if(this.data.secretarySwitch == undefined){
          this.$set(this.data, 'secretarySwitch', '0');
        }
        if(this.data.secretarySubProcSwitch == undefined){
          this.$set(this.data, 'secretarySubProcSwitch', '0');
        }
        if(this.data.commentSwitch == undefined){
          this.$set(this.data, 'commentSwitch', '0');
        }
        if(this.data.moreCommentSwitch == undefined){
          this.$set(this.data, 'moreCommentSwitch', '0');
        }
        if(this.data.commentModifyScope == undefined){
          this.$set(this.data, 'commentModifyScope', 'self');
        }
        if(this.data.commentCheckMode == undefined){
          this.$set(this.data, 'commentCheckMode', this.commentCheckModes[0].value);
        }
        if(this.data.completeComment == undefined){
          this.$set(this.data, 'completeComment', 'no');
        }
        if(this.data.transmitComment == undefined){
          this.$set(this.data, 'transmitComment', 'no');
        }
      },
      showHandledNode(f){
        var me =  this;

        var selectNode = '';
        if(me.data[f.id]){
          selectNode = me.data[f.id];
        }
        PF.show('tree',{treeData:me._getActivities(['start','end','circular','sub-proc']),selectFirst:false, selectNode:selectNode},function(res){
          me.$set(me.data,f.id,res.id);
          me.$set(me.data,f.name,res.name);
        });

      },
      showCanAgentRecordFlows(f){
        var me =  this;
        var checkFlows;
        if(me.data[f.id]){
          checkFlows=me.data[f.id].split(',');
        }
        PF.show('tree',{treeData:me._getCanAgentRecordFlows(['start','end','circular','sub-proc']), checkNodes:checkFlows, multiple:true,clearBtn:true},function(res){
          var flowNames = [];
          var flowIds = [];
          res.forEach(item => {
            flowNames.push(item.name);
            flowIds.push(item.id);
          });
          me.$set(me.data,f.id,flowIds.join(','));
          me.$set(me.data,f.name,flowNames.join(','));
        });
      },
      showDept(){
        var me  = this;
        var selectNode = '';
        if(me.data['relativeGroup']){
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree',{url: this.mwUrl("/api/org/listDepartment"), selectFirst:false,selectNode:selectNode, search:true, async:true, singleLeaf:false},function(res){
          me.$set(me.data,'relativeGroup',res.id);
          me.$set(me.data,'relativeGroupName',res.name);
        });
      },
      showRole(f){
        var me  = this;
        var selectNode = '';
        if(me.data[f.id]){
          selectNode = me.data[f.id];
        }
        //
        PF.show('tree',{url: this.mwUrl("/api/org/listFlowGroupedRole"),selectFirst:false, selectNode:selectNode, search:true,clearBtn:true},function(res){
          me.$set(me.data,f.id,res.id);
          me.$set(me.data,f.name,res.name);
        });
      },
      showFlowButton(){
        var me  = this;
        var value=[];
        for(var i=0;i<me.data.buttons.length;i++){
          value.push(me.data.buttons[i].action);
        }
        PF.show('treeTable', {
          url: me.mwUrl("/api/app/listActionComponentByTypeTree"),treeDefaultParams: {type: "系统分类/表单/流程",flag:0}
          ,size: 'small_large',
          selectFirst: true,asyncLoadOnce:true,clearBtn: true, title: '选择动作脚本', changed: function (data) {
            let me = this;
            me.defaultParams = {type: data.code, flag:2};
          }, api: 'app.getAllButton', singleSelect: false
        }, function (res) {
          let btns=[];
          if (res && res.length > 0) {
            res.forEach(v=>{
              btns.push({name:v.name,action:v.action});
            })
          }
          me.$set(me.data,'buttons',btns);
        });
      },
      showFlowScriptSet(type){
        var me = this;
        var p = {};
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if(scriptActions){
          p.scriptActions = scriptActions;
        }else{
          p.scriptActions ={};
        }
        PF.show('flowScriptSet',p,function(res){
          me.$set(me.data,'scriptActions',res);
        })
      },
      showFormOperAuth(){
        var me  = this;
        var moduleId = me.params.moduleId;
        var appId = me.params.applicationId;
        var checkNodes=[];
        for(var i=0;i<me.data.operAuths.length;i++){
          checkNodes.push(me.data.operAuths[i].id);
        }
        PF.show('tree', {url: this.mwUrl
        ("/api/app/listModuleFormOperAuthTree"), checkNodes:checkNodes,search:
          true,multiple:true,singleLeaf:false,clearBtn:true,multipleLeaf:false,
          defaultParams:{moduleId:moduleId, appId:appId}}, function (res) {
          let auths=[];
          if (res && res.length > 0) {
            res.forEach(v=>{
              if(v.id){
                auths.push({name:v.name,id:v.id});
              }
            })
          }
          me.$set(me.data,'operAuths',auths);
        });
      },

      clearField:function(){
        var me=this;
        function contains(obj) {
          for(var i=0;i<me.fields.length;i++){
            if(me.fields[i]==obj){
              return true
            }
          }
          return false;
        }
        var del=[]
        for(var s in me.data){
          if(!contains(s)){
            del.push(s)
          }
        }
        for(var i=0;i<del.length;i++){
          delete me.data[del[i]]
        }
      },
      changeType:function(val){
        parent.$emit("updateShape", {id: this.data.id, type: val})
        this.params.changeType(val);
      },
      changeGroupType:function(val){
        var me = this;
        var oldUt = me.data.userType;
        if('bind-group'==val){
          me.userTypes = me.bindUserTypes;
          var exist = false;
          me.bindUserTypes.forEach(v=>{
            if(v.value==oldUt){
              exist = true;
            }
          });
          if(!exist){
            me.$set(me.data,'userType',me.userTypes[0].value);
          }
        }else{
          me.userTypes = me.defaultUserTypes;
          var exist = false;
          me.bindUserTypes.forEach(v=>{
            if(v.value==oldUt){
              exist = true;
            }
          });
          if(exist){
            me.$set(me.data,'userType',me.userTypes[0].value);
          }
        }
      },
      showSubProcess(){
        var me = this;
        var selectNode = '';
        if(me.data.secSubProcessDefKey){
          if(me.data.secSubProcessModuleId){
            selectNode = me.data.secSubProcessDefKey+'|'+me.data.secSubProcessModuleId;
          }else{
            selectNode = me.data.secSubProcessDefKey;
          }
        }
        PF.show('tree',{url: this.mwUrl("/api/process/listModuleLatestProcDefTree"), singleLeaf:true, selectFirst:false,selectNode:selectNode, search:true/*, defaultParams:{appId:me.params.applicationId}*/},function(res){
          if(res) {
            if(res.id) {
              var ids = res.id.split('|');
              me.$set(me.data, 'secSubProcessDefKey', ids[0]);
            } else {
              me.$set(me.data, 'secSubProcessDefKey', res.id);
            }
            me.$set(me.data, 'secSubProcessDefName', res.name);
            me.$set(me.data, 'secSubProcessApplicationId', res.appId);
            me.$set(me.data, 'secSubProcessModuleId', res.moduleId);

            delete me.data.subProcessSecActivityId;
            delete me.data.subProcessSecActivityName;
            delete me.data.subProcessLeaderActivityId;
            delete me.data.subProcessLeaderActivityName;
          }
        });
      },
      showSubProcessNode(fid, fname){
        var me = this;
        var key = me.data.secSubProcessDefKey;
        if(key){
          var selectNode = '';
          if(me.data[fid]){
            selectNode = me.data[fid];
          }
          var appId = me.params.applicationId;
          if(me.data.secSubProcessApplicationId){
            appId = me.data.secSubProcessApplicationId;
          }
          PF.show('tree',{url: this.mwUrl("/api/process/getSubProcessStartActivities"), selectFirst:false, selectNode:selectNode,defaultParams:{key:key, appId:appId}},function(res){
            me.$set(me.data, fid, res.id);
            me.$set(me.data, fname, res.name);
          });
        }
      },
      _getActivities(excludeActivityTypes){
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(a=>{
          exclude = false;
          excludeActivityTypes.forEach(et=>{
            if(et==a.extends){
              exclude = true;
            }
          });
          if(!exclude){
            treeData.push({id:a.id, text:a.parameters.name, name:a.parameters.name});
          }
        });
        return treeData;
      },
      _getActivityFlows(flowTypes){
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var actNames = {};
        activities.forEach(a=>{
          actNames[a.id]=a.parameters.name;
        });
        var flows = processDataItems['SEQUENCE-FLOW'];
        var treeData = [];
        var exclude;
        flows.forEach(f=>{
          exclude = false;
          flowTypes.forEach(et=>{
            if(et==f.parameters.type){
              var name = actNames[f.parameters.from]+'-'+actNames[f.parameters.to];
              treeData.push({id:f.id,text:name, name:name, sourceId_targetId:f.parameters.from+'-'+f.parameters.to});
            }
          });
        });
        return treeData;
      },
      _getCanAgentRecordFlows(excludeActivityTypes){
        var me = this;
        var currentNodeId= me.data.id;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var acts = {};
        var actNames = {};
        activities.forEach(a=>{
          acts[a.id]=a;
          actNames[a.id]=a.parameters.name;
        });
        var treeData = [];
        var flows = processDataItems['SEQUENCE-FLOW'];
        var exclude;
        flows.forEach(f=>{
          exclude = false;
          if(f.parameters.from == currentNodeId){
            //先判断流向类型 排除运转发送部门
            if('startSubProcess'==f.parameters.type && 'DEP'==f.parameters.sendUnit){
              exclude = true;
            }
            if(!exclude){
              var act = acts[f.parameters.to];
              excludeActivityTypes.forEach(at=>{
                if(at==act.extends){
                  exclude = true;
                }
              });
              if(!exclude){
                var name = f.parameters.name;
                if(!name){
                  name = actNames[f.parameters.from]+'-'+actNames[f.parameters.to];
                }
                treeData.push({id:f.id,text:name, name:name, sourceId_targetId:f.parameters.from+'-'+f.parameters.to});
              }
            }
          }
        });
        return treeData;
      }
    }
  }
  return node_dynamic
}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flowConfig/node_dynamic.js